import { getSession } from 'actions/session';

import { INVITE_UPDATED, CONNECT_SUCCESS, PERSIST_REHYDRATE } from 'constants/actions';

export const fetchSession = store => next => async action => {
  const isAuth = (
    action.payload && 
    action.payload.session && 
    action.payload.session.isAuth
  ) || store.getState().session.isAuth;

  if ((action.type === PERSIST_REHYDRATE || action.type === INVITE_UPDATED) && isAuth) {
    store.dispatch(getSession)();
  }

  if (action.type === CONNECT_SUCCESS) {
    store.dispatch(getSession)();
  }

  return next(action);
};